export default __webpack_public_path__ + "static/media/index.0cf27743.less";